import { BlurRadialIcon } from './BlurRadialIcon';

/**
 * author: Google
 * id 29F42A3B-BCD5-45BA-9B87-35F97FE9438D
 * name blur-radial
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blur-radial.svg
 * tags
 */
export const BlurCircularIcon = BlurRadialIcon;
export default BlurCircularIcon